<template>
    <div class="simulations-view">
        <div class="content">
            <div class="simulation-view__banner">
                <div class="banner-title">
                    <span class="title-span">{{ $t("winWith") }}<br>
                        <h5 class="tournaments-word">{{ $t("fundingSimulations.mainText") }} <br>{{
                            $t("fundingSimulations.subText") }}</h5>
                    </span>
                </div>
                <div class="banner-text" v-if="false">
                    <p><span class="special-text">{{ $t("thanksTo_NewFrontPage") }}</span><br>
                        {{ $t("sponsorText") }}</p>
                    <img class="partner-logo" @click="redirect()"
                        src="https://proprietaryfirms.tech/wp-content/uploads/2023/07/logo-full-margin.png"
                        alt="pft-logo.png">
                </div>
                <img class="banner-img" src="https://hub.swiset.com/wp-content/uploads/2024/08/Ilus-simulation-main-06.png"
                    alt="simulaciones.png">
            </div>
            <section v-if="bestPropMatchImg" class="road">
                <div class="road-heading">
                    <div class="road-heading__items">
                        <h2>{{ $t("myRoad") }}</h2>
                    </div>
                </div>
                <div class="road-cards-container">
                    <RoadStatCard :name="$t('road.totalSimulations')" :value="allTest.length.toString()"
                        status="normal">
                    </RoadStatCard>
                    <RoadStatCard :name="$t('road.passedSimulations')" :value="achievedTests.toString()"
                        status="success">
                    </RoadStatCard>
                    <RoadStatCard :name="$t('road.bestPropMatch')" :img="bestPropMatchImg"
                        :value="!bestPropMatchImg ? 'N/A' : undefined" status="success"></RoadStatCard>
                </div>
            </section>
            <section class="simulations">
                <div class="simulations-heading">
                    <div class="simulations-heading__items">
                        <h2>{{ $t("mySimulations") }}</h2>
                        <div class="tabs">
                            <input checked type="radio" id="active-option" name="tabs" value="active"
                                v-model="activeTab" />
                            <label class="tab" for="active-option"><i class="fa-regular fa-hourglass-half" />{{
                                $t("tabs.active") }}</label>
                            <input type="radio" id="finished-option" name="tabs" value="finished" v-model="activeTab" />
                            <label class="tab" for="finished-option"><i class="fa-regular fa-flag-checkered"></i>{{
                                $t("tabs.finished") }}</label>
                            <span class="glider"></span>

                        </div>
                    </div>
                    <v-chip @click="openWizard" outlined :disabled="!this.$store.state.user.isPro && activeTests >= 3"
                        ><i class="fa-regular fa-chart-simple mr-2"></i>{{
                            $t("createSimulation") }}</v-chip>
                    <div class="tooltip">
                        {{ $t("tooltipMsg") }}
                    </div>
                </div>
                <div class="cards-container-parent" @scroll="(e) => updateSliderControlsStatus(e.target)">
                    <div class="cards-container">
                        <SimulationCard v-for="(test, index) in filteredTest" :key="index" :testId="test.id"
                            :simulationMsgState="{ text: capitalizeFirstLetter(test.participantStatus.toLowerCase()), color: test.participantStatus.toLowerCase() }"
                            :imgUrl="test.fundingChallengePhase.fundingChallenge.fundingVendor.logoUrl"
                            :simulationInfo="[{ text: `${$t('startedAt')}: ${getFormattedDate(new Date(test.currentCycleStartTime))}`, icon: 'fa-regular fa-calendar' }, { text: `${$t('account_NewFrontPage')}: ${test.brokerAccount.identifier}`, icon: 'fa-regular fa-user' }]"
                            :profitTarget="test.fundingChallengePhase.target - test.fundingChallengePhase.initialBalance"
                            :currentProfit="test.currentProfit"
                            :progress="(test.currentProfit / (test.fundingChallengePhase.target - test.fundingChallengePhase.initialBalance)) * 100"
                            :brokerName="test.fundingChallengePhase.fundingChallenge.fundingVendor.market.name">
                        </SimulationCard>
                    </div>
                    <h2 class="no-simulations-text" v-if="filteredTest.length == 0">
                        {{ activeTab == 'active' ? $t("noActiveSimulations") : $t("noFinishedSimulations") }}
                    </h2>
                </div>
                <div class="slider-controls">
                    <button @click="scrollContainer(false)" class="prev-btn">
                        <i class="fa-regular fa-chevron-left"></i>
                    </button>
                    <button @click="scrollContainer(true)" class="next-btn">
                        <i class="fa-regular fa-chevron-right"></i>
                    </button>
                </div>
                <p class="active-simulations">{{ $t("youHave") }} {{ activeTests }}/{{ allTest.length }} {{
                    $t("activeSimulations") }}</p>
            </section>
        </div>
        <Wizard
            :class="'simulations-wizard ' + (wizardOpen ? 'three ' : '') + (!wizardOpen && fromWizard ? 'three out' : '')"
            :fromButton="true" :hideWizard="hideWizard"></Wizard>
        <LoadingOverlay style="position: fixed;" :loading="loading"></LoadingOverlay>
    </div>
</template>

<script>
import SimulationCard from '../components/SimulationCard.vue';
import FundingRepository from '../../../../repositories/funding';
import LoadingOverlay from '../../../../components/LoadingOverlay.vue';
import RoadStatCard from '../components/RoadStatCard.vue';
import Wizard from '../components/Wizard/Wizard.vue';

export default {

    components: {
        SimulationCard,
        LoadingOverlay,
        RoadStatCard,
        Wizard
    },
    props: {
        createNew: Boolean
    },
    watch: {
        activeTab: function () {
            if (this.activeTab == "finished") {
                this.filteredTest = this.allTest.filter(test => this.otherStates.includes(test.participantStatus))
            }
            else if (this.activeTab == "active") {
                this.filteredTest = this.allTest.filter(test => test.participantStatus == "ACTIVE")
                this.activeTests = this.filteredTest.length
            }
            this.$nextTick(() => {
                this.updateSliderControlsStatus(document.querySelector('.simulations-view .simulations .cards-container-parent'));
            })
        },
        allTest: function () {
            this.achievedTests = this.allTest.filter(t => t.participantStatus === 'WINNER').length;
        }
    },
    data: function () {
        return {
            activeTab: "",
            loading: false,
            allTest: [],
            activeTests: 0,
            filteredTest: [],
            otherStates: ["PAUSED", "ACHIEVED", "FAILED", "ABANDONED"],
            achievedTests: 0,
            bestPropMatchImg: undefined,
            wizardOpen: false,
            fromWizard: false
        }
    },
    async mounted() {
        await this.init()
        this.activeTab = "active";
    },
    beforeDestroy() {
        document.querySelector("html").classList.remove("modal-open");
    },
    methods: {
        async init() {
            this.loading = true;
            await FundingRepository.allFundingTestOfUser().then((response) => {
                this.allTest = response.data;
            });
            this.allTest.forEach((t) => {
                if (t.participantStatus == "WINNER") {
                    t.participantStatus = "ACHIEVED";
                }
                if (t.participantStatus == "DISQUALIFIED") {
                    t.participantStatus = "FAILED";
                }
            });
            this.setBestPropMatch();
            if (this.createNew) {
                this.openWizard();
            }
            this.loading = false;
        },
        scrollContainer(right) {
            let container = document.querySelector('.simulations-view .simulations .cards-container-parent');

            if (window.innerWidth <= 768) {
                container.scrollBy(right ? 420 : -463, 0);
            } else {
                container.scrollBy(right ? 400 : -400, 0);
            }
        },
        updateSliderControlsStatus(container) {
            let a = container.scrollLeft;
            let b = container.scrollWidth - container.clientWidth;
            //Scroll percentage (0-1)
            let c = a / b;
            if (c == 0) {
                container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".next-btn").removeAttribute("disabled");
            }
            else if (c == 1) {
                container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").removeAttribute("disabled");
            } else if (isNaN(c)) {
                container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
            } else {
                container.parentElement.querySelector(".next-btn").removeAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").removeAttribute("disabled", "disabled");
            }
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        getFormattedDate(date) {
            let year = date.getFullYear();
            let month = (1 + date.getMonth()).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');

            return month + '/' + day + '/' + year;
        },
        setBestPropMatch() {
            let winnnerProps = [];
            this.allTest.forEach((t) => {
                if (t.participantStatus == "ACHIEVED") {
                    let prop = winnnerProps.find(tw => tw.id == t.fundingChallengePhase.fundingChallenge.fundingVendor.id);
                    if (prop) {
                        prop.winCount = prop.winCount + 1;
                    } else {
                        winnnerProps.push({ id: t.fundingChallengePhase.fundingChallenge.fundingVendor.id, winCount: 1, imgUrl: t.fundingChallengePhase.fundingChallenge.fundingVendor.logoUrl })
                    }
                }
            });

            if (winnnerProps.length > 0) {
                let mostWinner = winnnerProps.reduce(
                    (prev, current) => {
                        return prev.winCount > current.winCount ? prev : current
                    }
                );
                if (mostWinner) {
                    this.bestPropMatchImg = mostWinner.imgUrl;
                } else {
                    this.bestPropMatchImg = undefined;
                }
            } else {
                this.bestPropMatchImg = undefined;
            }

        },
        redirect() {
            window.open('https://proprietaryfirms.tech/', '_blank');
        },
        openWizard() {
            this.wizardOpen = true;
            document.querySelector("html").classList.add("modal-open");
        },
        hideWizard() {
            this.wizardOpen = false;
            this.fromWizard = true;
            document.querySelector("html").classList.remove("modal-open");
        },

    }
}
</script>

<style lang="scss">
.simulations-view {
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        padding: 0 20px;
    }

    .simulation-view__banner {
        position: relative;
        background: linear-gradient(75deg, rgba(0, 0, 0, 1) 0%, rgba(0, 247, 132, 0.6) 100%);
        background-size: cover;
        background-repeat: no-repeat;
        height: 310px;
        border-radius: 15px;
        display: flex;
        flex-direction: row;
        margin-bottom: 82px;
        overflow: hidden;

        .banner-title {
            display: flex;
            position: absolute;
            top: 0;
            left: 0;
            font-family: "Avenir", sans-serif;
            font-weight: bold;
            
            span {
                font-size: 14px;
                line-height: 1;
                padding-top: 50px;
                padding-left: 50px;
                color: var(--v-white-base) !important;

                .tournaments-word {
                    font-size: 50px;
                    color: var(--v-white-base);
                }
            }
        }

        .banner-text {
            display: flex;
            position: absolute;
            flex-direction: row;
            right: 0;
            bottom: 0;
            padding: 44px 28px;
            background: #1B1B1B;
            border-top-left-radius: 15px;
            border-bottom-right-radius: 15px;
            justify-content: space-between;
            align-items: center;
            font-family: "Avenir", sans-serif;

            p {
                color: white !important;
                font-size: 14px;
                padding-right: 30px;
                font-weight: normal;

                .special-text {
                    color: var(--v-mainGreen-base);
                    font-size: 20px;
                    font-weight: bold;
                }
            }

            .partner-logo {
                height: 40px;
                cursor: pointer;
            }
        }

        @media (max-width: 768px) {
            display: none;
        }

        .banner-img {
            margin-left: auto;
            margin-right: auto;

            @media(max-width: 1120px) {
                display: none;
            }
        }
    }

    .road {
        display: flex;
        flex-direction: column;

        .road-heading {
            line-height: 1;

            .road-heading__items {
                h6 {
                    font-family: "Avenir", sans-serif;
                    font-size: 32px;
                    font-weight: bold;
                }

                @media(max-width: 768px) {
                    text-align: center;
                }
            }
        }

        .road-cards-container {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); // Adjust 200px as needed
            gap: 65px; // Adjust spacing between cards as needed
            margin-top: 40px;
            margin-bottom: 70px;

            .road-card {
                @media (max-width: 768px) {
                    margin: 0;
                    width: 100%;
                }
            }

            @media (max-width: 768px) {
                gap: 20px;
            }
        }
    }

    .simulations {

        .simulations-heading {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 40px;
            position: relative;

            @media (max-width: 768px) {
                flex-direction: column;
            }

            .simulations-heading__items {
                display: flex;
                align-items: center;
                min-width: 600px;

                @media (max-width: 768px) {
                    flex-direction: column;
                }

                h6 {
                    font-family: "Avenir", sans-serif;
                    font-size: 32px;
                    font-weight: bold;

                    @media (max-width: 768px) {
                        margin-bottom: 20px;
                        margin-top: 20px;
                    }
                }

                .tabs {
                    display: flex;
                    position: relative;
                    background-color: var(--v-lightGray-base);
                    border-radius: 10px;
                    margin-left: 38px;

                    @media (max-width: 768px) {
                        margin-bottom: 10px;
                    }

                    * {
                        z-index: 2;
                    }

                    input[type="radio"] {
                        &:checked {
                            &+label {
                                color: #000 !important;
                            }
                        }
                    }

                    input[type="radio"] {
                        display: none;
                    }

                    input[id="active-option"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(0);
                            }
                        }
                    }

                    label {
                        i {
                            padding-right: 16px;
                            font-size: 14px;
                        }
                    }

                    label[for=abandoned-option] {
                        width: 170px;
                    }

                    input[id="finished-option"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(100%);
                            }
                        }
                    }

                    input[id="abandoned-option"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(168%);
                                width: 172px;
                            }
                        }
                    }

                    .tab {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 146px;
                        padding-left: 10px;
                        padding-right: 10px;
                        height: 38px;
                        font-size: 16px;
                        font-weight: normal;
                        color: var(--v-mainBlack-base);
                        border-radius: 10px;
                        cursor: pointer;
                        transition: color 0.15s ease-in;
                        font-family: "Avenir", sans-serif;
                        font-size: 16px;
                    }

                    .glider {
                        position: absolute;
                        display: flex;
                        height: 38px;
                        width: 146px;
                        background-color: var(--v-mainGreen-base);
                        border-radius: 10px;
                        z-index: 1;
                        transition: 0.25s ease-out;
                    }

                }

            }

            .tooltip {
                display: none;
                position: absolute;
                border-radius: 5px;
                width: 260px;
                font-size: 14px;
                font-family: "Avenir", sans-serif;
                padding: 4px 8px;
                background: var(--v-cardHeaderBackground-base);
            }

            .simulations-heading__add-button {
                display: flex;
                align-items: center;
                padding: 10px;
                border-radius: 30px;
                background: transparent;
                border: 1px solid var(--v-mainGreen-base);
                color: var(--v-mainGreen-base);
                font-family: "Avenir", sans-serif;
                font-size: 16px;
                font-weight: normal;
                transition: box-shadow ease-in-out 0.1s;

                @media (max-width: 768px) {
                    position: absolute;
                    right: 0;
                    top: -50px;
                }

                &:disabled {
                    color: #9A9A9A;
                    border-color: #9A9A9A;

                    &:hover {
                        ~ {
                            .tooltip {
                                display: block;
                                right: 30px;
                                top: -80px;
                            }
                        }
                    }

                }

                i {
                    padding-right: 10px;
                }

                &:not([disabled]):hover {
                    box-shadow: 0px 0px 6px 0px rgba(0, 195, 97, 1);
                }

            }
        }

        .slider-controls {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-end;

            @media (max-width: 768px) {
                justify-content: center;
            }

            button {
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                outline: 0;
                margin: 5px 10px;
                width: 38px;
                height: 38px;
                background: var(--v-mainGreen-base);
                padding: 0;

                i {
                    color: var(--v-mainWhite-base);
                }

                &:disabled {
                    background: var(--v-mainBlack-base);
                    opacity: 0.1;

                    i {
                        color: var(--v-mainWhite-base);
                    }
                }
            }
        }

        .cards-container-parent {

            -ms-overflow-style: none;
            scrollbar-width: none;
            overflow: scroll;
            scroll-behavior: smooth;

            &::-webkit-scrollbar {
                display: none;
            }

            .cards-container {
                width: fit-content;
                display: flex;
                justify-content: flex-start;


                .simulation-card {
                    margin-right: 50px;
                    margin-bottom: 20px;
                    min-width: 373px;

                    @media (max-width: 768px) {
                        width: 80vw;
                        margin-right: 10px;
                        margin-left: 10px;
                    }
                }

            }

            .no-simulations-text {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 32px;
                font-family: "Avenir", sans-serif !important;
                text-align: center;
                height: 300px;
                color: var(--v-mainBlack-base);
                opacity: 0.2;
            }
        }

        .active-simulations {
            margin-bottom: 20px;
            margin-top: 20px;
            font-weight: bold;

            @media (max-width: 768px) {
                margin-top: 30px !important;
                font-weight: normal;
                margin: auto;
                text-align: center;
            }
        }
    }

    .content {
        z-index: 0;
        position: relative;
    }

    .simulations-wizard {
        position: fixed;
        padding-left: 120px;
        @media (max-width: 768px) {
            padding-left: 30px;;
        }
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        transform: scale(0);
        z-index: 1;
        background: var(--v-mainWhite-base);
        overflow-y: auto;

        &.three {
            z-index: 0;
            transform: scale(1);
            animation: moveUp 0.7s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;

            +.content {
                z-index: 1;
                animation: slideUpLarge 0.7s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
            }

            &.out {

                transform: scale(0);
                animation: moveDown 0.7s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;

                +.content {
                    animation: slideDownLarge 0.7s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
                }
            }
        }
    }

    @keyframes slideUpLarge {
        0% {
            transform: translateY(0%);
        }

        100% {
            transform: translateY(-100%);
        }
    }

    @keyframes slideDownLarge {
        0% {
            transform: translateY(-100%);
        }

        100% {
            transform: translateY(0%);
        }
    }

    @keyframes moveUp {
        0% {
            transform: translateY(100vh);
        }

        100% {
            transform: translateY(0);
        }
    }

    @keyframes moveDown {
        0% {
            transform: translateY(0px);
        }

        100% {
            transform: translateY(100vh);
        }
    }

}
</style>